module.exports = __webpack_public_path__ + "img/itop.c0171755.png";